import * as React from 'react'
import { Field } from './Field'
import { styled } from 'next-yak'
import * as S from '../../../styles'
import { type AutocompleteProps, Autocomplete } from '../autocomplete/Autocomplete'
import { FieldStatus } from './FieldStatus'

export type AutocompleteFieldProps = AutocompleteProps & {
  className?: string
  /** @default String(Math.random()) */
  id?: string
  label?: React.ReactNode
  description?: string
  context?: string
  error?: React.ReactNode
  success?: React.ReactNode
  format?: 'wide'
}

export const AutocompleteFieldComponent = React.forwardRef<HTMLInputElement, AutocompleteFieldProps>(
  function AutocompleteFieldComponent(
    { className, label, description, id = String(Math.random()), error, success, context, ...autocompleteProps },
    ref,
  ) {
    return (
      <AutocompleteFieldWrapper
        className={className}
        htmlFor={id}
        label={label}
        context={context}
        description={description}
        format={'wide'}
        data-testid="component:address.autocomplete"
      >
        <Autocomplete {...autocompleteProps} id={id} ref={ref} />
        {(error || success) && <FieldStatus error={error} success={success} />}
      </AutocompleteFieldWrapper>
    )
  },
)

export const AutocompleteField = styled(AutocompleteFieldComponent)<AutocompleteFieldProps>``
AutocompleteField.displayName = 'AutocompleteField'

export const AutocompleteFieldWrapper = styled(Field)`
  ${S.field.Status} {
    margin-top: 10px;
  }

  ${S.field.Title}, ${S.field.Description} {
    margin-bottom: 7px;
  }
`
